<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-3 p-0 m-0">
            <bita-bootbutton
              type="primary"
              title="افزودن نقش"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="createRole"
            />
          </div>
          <hr />
          <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-permissions="permission"
      :props-data="editForm"
      modal-id="edit-modal"
      title="ویرایش نقش"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :props-data="editForm"
      :props-permissions="permission"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="افزودن نقش"
      @on-submit="handleCreate"
    />
  </div>
</template>
<script>
import RoleForm from "./Form";
export default {
  components: { "form-modal": RoleForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        {
          title: "مدیریت نقش",
          link: "/management/roles",
          active: true,
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,
      role: {
        name: "",
        permissions: [],
      },
      permission: {},
      editForm: { asfas: "asfasf" },
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام نقش", width: "100px" },
        { field: "fa_name", title: "نام فارسی نقش", width: "100px" },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
             width: "100px"
        },
        {
          title: "عملیات",
          command: [],
           width: "150px"
        },
      ],
    };
  },
  computed: {},
  mounted() {
    Promise.all([this.getAllPermissions()]).then((res) => {
      this.permission = res[0].data;
    });
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
  },
  methods: {
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$resetGrid();
      this.$persistClient("get", "roles")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    getAllPermissions() {
      return this.$persistClient("get", "permissions");
    },
    save() {
      this.$refs.test.validate().then((result) => {
        if (result) {
          this.isLoadingForm = true;
          this.$persistClient("post", "roles", this.role)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", "نقش مورد نظر ایجاد شد");
              this.role = {
                name: "",
                permissions: [],
              };
              this.$refs.test.reset();
            })
            .finally(() => {
              this.isLoadingForm = false;
            });
        }
      });
    },
    edit(e) {
      this.isLoadingModal = true;
      const _this = this;
      this.editForm = this.$refs.grid.getSelectedGridRow(e);
      let permissionCollect = collect(this.editForm.permissions);
      setTimeout(function() {
        _this.editForm.permission_id = permissionCollect.pluck("id").toArray();
        _this.editForm.permission_id = _this.editForm.permission_id.filter(
          function(el) {
            return el;
          }
        );
        _this.isLoadingModal = false;
      }, 500);
      this.statusChangeModalEdit();
    },
    delete(e) {
      let role = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف ${role.name} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `roles/${role.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    createRole() {
      this.editForm = {};
      this.statusChangeModalCreate();
    },
    handleEdit(e) {
      this.isLoadingModal = true;
      let data = {
        id: e.id,
        name: e.name,
        fa_name: e.fa_name,
        permission_id: e.permission_id,
      };
      this.$persistClient("patch", `roles/${e.id}`, data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalEdit();
        });
    },
    handleCreate(e) {
      this.isLoadingModal = true;
      let data = {
        id: e.id,
        name: e.name,
        fa_name: e.fa_name,
        permission_id: e.permission_id,
      };
      this.$persistClient("post", "roles", data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
        })
        .finally((res) => {
          this.isLoadingModal = false;
          this.statusChangeModalCreate();
        });
    },
  },
};
</script>
